export default __webpack_public_path__ + "static/media/icon_10_on.e4951864.png";